export default {
  day: "Ngày",
  hour: "Giờ",
  min: "Phút",
  sesc: "Giây",
  cancel: "Hủy",
  confirm: "Xác nhận",
  showMore: 'Xem thêm',
  hideMore: 'Ẩn',
  per_sale: {
    title: "Giai đoạn Bán công khai kết thúc sau {days} ngày {hours} giờ {mins} phút {secs} giây",
    title1: "Tham gia Bán công khai yêu cầu KYC trước tiên",
    text: "Mua DLC",
    text1: "Tham gia KYC"
  },
  meau: {
    nav1: "DeepLink là gì?",
    nav2: "Làm thế nào để mua?",
    nav3: "Bản Trắng",
    nav4: "Bài thuyết trình",
    nav5: "Câu hỏi thường gặp",
    nav6: "Nghiên cứu",
    add: "Địa chỉ:",
    link: "Kết nối ví"
  },
  home: {
    intro: {
      title: "Bán công khai DeepLink",
      text: "Đếm ngược đến Giai đoạn bán công khai đầu tiên:",
      text1: "Hiện đang tiến hành KYC",
      text2: 'Đếm ngược đến cuối đợt Public Sale đợt 5',
      text3: 'Đếm ngược đến đợt bán công khai thứ hai:',
      tip: "Vui lòng đảm bảo rằng quá trình xác minh Khách hàng của bạn (KYC) được hoàn thành trước khi mua (DLC) Tokens.",
      tip1: 'Xin vui lòng không lặp lại việc mua hàng'
    },
    desc: {
      title: "DeepLink bao gồm hai thành phần: Giao thức DeepLink và Phần mềm DeepLink.",
      left: {
        text: "Mỗi trong số các thành phần này sử dụng token DeepLink để thanh toán",
        text1: "Giao thức DeepLink là một giao thức chơi game đám mây trí tuệ nhân tạo phi tập trung,",
        text2: "Kết hợp trí tuệ nhân tạo và công nghệ blockchain để cung cấp công nghệ hiển thị game với độ trễ cực thấp. Phần mềm DeepLink là phần mềm điều khiển game từ xa và nền tảng chơi game đám mây được phát triển dựa trên Giao thức DeepLink. Dựa trên Giao thức DeepLink, cũng có các nền tảng quán internet đám mây và máy chơi game đám mây blockchain, máy chơi game đám mây cầm tay blockchain và các sản phẩm khác",
        text3: "100% An toàn & Đã xác minh",
        btn1: "Giới thiệu về Giao thức DeepLink",
        btn2: "Giới thiệu về Phần mềm DeepLink"
      },
      right: {
        text1: "Bán công khai đang diễn ra",
        text1_1: "KYC đang diễn ra",
        text1_2: 'Đang tiến hành Public Sale Giai đoạn {pre_num1}',
        // text2: 'DLC price: 1DLC={price}USDT, remaining {days} days {hour} hours and {min} minutes',
        text2: "Giá DLC: 1DLC={price}USDT",
        text3: "Bán công khai thứ {pre_num} đã kết thúc",
        text4: "Giai đoạn {pre_num1} sắp bắt đầu",
        text5: "Bán công khai sắp bắt đầu",
        text6: "Vui lòng hoàn thành quá trình Xác minh Khách hàng của bạn (KYC) trước khi tham gia bán công khai. Xin cảm ơn sự hợp tác của bạn.",
        // text7: 'Thưởng thêm 10% token ở giai đoạn hiện tại, phần thưởng sẽ giảm xuống 5% ở giai đoạn tiếp theo',
        text7: 'Thưởng thêm 5% token ở giai đoạn hiện tại, không có thưởng thêm ở giai đoạn tiếp theo',
        text8: 'Tham gia cộng đồng và tham gia rút thăm trúng thưởng 10,000 USDT và DLC',
        process: "{process}% đã hoàn thành",
        btn1: "Tham gia xác minh KYC",
        btn1_1: 'KYC đã hoàn tất',
        text7_1: "Quá trình xác minh KYC ví hiện tại đang được xem xét, vui lòng đợi",
        text7_2: "Xác minh KYC ví hiện tại đã thành công!",
        text7_3: "Xác minh KYC ví hiện tại đã thất bại, vui lòng gửi lại! ",
        text7_4: "Xác minh KYC ví hiện tại chưa được gửi",
        btn2: "Mua TOKEN DLC",
        btn3: "Liên kết được đề xuất 5%",
        btn3_1: "Liên kết được đề xuất 10%",
        btn3_2: "Liên kết được đề xuất 15%",
        btn3_3: "Liên kết được đề xuất 20%"
      },
      success: "Liên kết đã được sao chép vào clipboard",
      error1: "Vui lòng kết nối ví trước để nhận mã mời độc quyền và nhận phần thưởng",
      error2: "Ví chưa được kết nối, vui lòng kết nối ví trước",

      error3: 'Chứng nhận KYC đang được xem xét, vui lòng đợi xem xét trước khi mua',
      error4: 'Đánh giá chứng nhận KYC không thành công. Nếu bạn muốn mua, vui lòng gửi lại thông tin chứng nhận KYC',
      error5: 'Không lấy được thông tin chứng nhận KYC, vui lòng thử lại sau',
      error6: 'Vui lòng tham gia mua hàng sau khi đếm ngược kết thúc',
      error7: 'Giai đoạn 3 đã kết thúc, vui lòng đợi bắt đầu Giai đoạn 4',
      tip1: 'DLC vẫn chưa được phát hành',
      tip2: 'DLC đã được phân phối vào ví của người dùng',
      tip3: 'Thanh toán thành công'
    },
    rule: {
      title: "Mô tả các quy tắc",
      text1: "Xác minh KYC là bắt buộc, yêu cầu gửi tài liệu nhận dạng như thẻ căn cước, hộ chiếu hoặc giấy phép lái xe. Cư dân của Singapore, Trung Quốc, Hoa Kỳ, Hàn Quốc và một số quốc gia khác không đủ điều kiện tham gia IDO.",
      text2: "Sau khi kết thúc Bán công khai, DLC sẽ được niêm yết trên sàn DEX trong vòng 7 ngày và trên sàn CEX trong vòng 15 ngày.Địa chỉ hợp đồng thông minh chuỗi BSC của token DLC: 0xD610Be30b06A3828A27D608a38F1E85faAFdEDcC",
      text3: "Mỗi mua 20,000,000 DLC sẽ được tặng một máy đào game GPU DeepLink trị giá 1500 USD. Ưu đãi này chỉ dành riêng cho Nhật Bản và Châu Âu, với chi tiết giao hàng được thông báo qua email.",
      text3_btn: "Tìm hiểu về máy đào game GPU tại nhà",
      text4: "Đợt bán công khai sẽ kết thúc 48 giờ sau khi ra mắt, với mỗi DLC có giá 0,003 USDT. 40% số token sẽ vẫn được mở khóa, trong khi 60% còn lại sẽ được mở khóa dần dần bắt đầu từ ngày 31 tháng 8 năm 2024. Cần lưu ý rằng 40% DLC sẽ được chuyển đến địa chỉ ví được chỉ định của bạn trong vòng vài phút sau khi mua và 60% DLC còn lại sẽ được mở khóa thành 6 đợt, 30 ngày một lần. Khi đến thời gian mở khóa, DLC sẽ được chuyển đến địa chỉ ví của bạn.",
      text5: "Bán công khai được chia thành 5 lần,",
      table: {
        table1_text1: "Sân khấu",
        table1_text2: "2024/06/05-06/07",
        table1_text3: "2024/06/09-06/29",
        table1_text4: "2024/06/29-07/13",
        table1_text5: '2024/07/13-08/05',
        table1_text6: '2024/08/05-09/11',
        table2_text1: "Số lượng DLC",
        table2_text2: "350,000,000DLC",
        table2_text3: "400,000,000DLC",
        table2_text4: "300,000,000DLC",
        table2_text5: '450,000,000DLC',
        table2_text6: "Chưa xác định",
        table3_text1: "Giá DLC (USDT)",
        table3_text2: "0.003",
        table3_text3: "0.003",
        table3_text4: "0.003",
        table3_text5: "0.003",
        table3_text6: "0.003",
        table4_text1: "Thưởng",
        table4_text2: "Tặng thêm 20% DLC",
        table4_text3: "Tặng thêm 15% DLC",
        table4_text4: "Tặng thêm 10% DLC",
        table4_text5: "Tặng thêm 5% DLC",
        table4_text6: "KHÔNG",
        table5_text1: "Số tiền",
        table5_text2: "1,050,000 USDT",
        table5_text3: '1,200,000 USDT',
        table5_text4: '900,000 USDT',
        table5_text5: '1,350,000 USDT',
        table5_text6: "Chưa xác định"
      }
    },
    ecology: {
      title: "Tổng quan về Hệ sinh thái Giao thức DeepLink",
      block1_title: "Phần mềm DeepLink",
      block1_text1: "Chức năng cốt lõi của phần mềm DeepLink là điều khiển từ xa và nền tảng chơi game đám mây",
      block1_text2: "Giao thức DeepLink bao gồm cả Giao thức DeepLink và Phần mềm DeepLink. Tại cốt lõi của nó, Phần mềm DeepLink cung cấp khả năng điều khiển từ xa và chơi game đám mây, cho phép người dùng tham gia chơi game từ xa, làm việc từ xa và truy cập các dịch vụ chơi game dựa trên đám mây. Hiện tại, phần mềm này có một cộng đồng người dùng toàn cầu trải rộng 110 quốc gia, với hơn 400.000 lượt tải xuống và việc tạo ra hơn 200.000 ví tiền điện tử trên toàn cầu.",
      block1_btn1: "Tìm hiểu về phần mềm DeepLink",
      block2_title: "Quán internet đám mây và E-Sports đám mây",
      block2_text1: "Quán internet đám mây đại diện cho một mô hình sáng tạo cho các quán internet và dịch vụ e-sports, tận dụng công nghệ hiển thị với độ trễ cực thấp của Giao thức DeepLink.",
      block2_text2: "Trong cài đặt này, các trò chơi và ứng dụng nằm trên các máy chủ GPU đám mây thay vì máy tính cục bộ, cho phép người dùng truy cập và chơi game thông qua các dịch vụ đám mây mà không cần máy chủ GPU cục bộ hiệu suất cao. Triển khai quán internet đám mây dựa trên công nghệ DeepLink đang diễn ra ở một số quốc gia, bao gồm Hàn Quốc, Trung Quốc, Nhật Bản, Việt Nam, Philippines và Ấn Độ, với sự tham gia của các nhà phát triển như HYCONS, ZESTCLOUD, GLOWSTEAM và TIKEREN, với các ví dụ hoạt động đã được thiết lập ở Hàn Quốc.",
      block2_btn1: "Xem video",
      block2_btn2: "Hiểu về quán internet đám mây",
      block3_title: "Máy chơi game đám mây blockchain all-in-one",
      block3_text1: "Máy chơi game all-in-one đám mây là gì?",
      block3_text2: "Máy chơi game đám mây blockchain all-in-one đại diện cho một bước nhảy vọt trong phần cứng chơi game, cung cấp tỷ lệ làm mới FPS cao cho một trải nghiệm chơi game e-sports mượt mà. Được phát triển bởi Tập đoàn HKC, máy chơi game đám mây blockchain all-in-one của TIKEREN sử dụng công nghệ hiển thị với độ trễ cực thấp của DeepLink để kết nối với các máy chủ GPU đám mây trong thời gian thực, tăng cường hiệu suất hiển thị trò chơi.",
      block3_btn1: "Hiểu về máy chơi game đám mây blockchain all-in-one",
      block4_title: "Máy chơi game cầm tay đám mây blockchain",
      block4_text1: "Máy chơi game cầm tay đám mây là gì?",
      block4_text2: "Máy chơi game cầm tay đám mây, xây dựng trên công nghệ hiển thị với độ trễ cực thấp của DeepLink, đưa ra một lựa chọn tiết kiệm chi phí so với các máy chơi game cầm tay truyền thống trong khi vẫn mang lại một trải nghiệm chơi game 3A mượt mà. Bằng cách kết nối với các máy chủ GPU đám mây để hiển thị trò chơi trong thời gian thực, nó giảm chi phí của máy chơi game đi 70%.",
      block4_btn1: "Hiểu về máy chơi game cầm tay đám mây blockchain"
    },
    coverage: {
      title: 'Bản đồ phân bố người dùng toàn cầu của phần mềm DeepLink',
      text: 'Tổng số người dùng DeepLink:'
    },
    track: {
      title: 'DeepLink Protocol là sự kết hợp của DePIN+AI+Game',
       text: 'Thuộc về các lĩnh vực phổ biến hiện nay của ngành công nghiệp blockchain',
       block1_title: 'Quy mô thị trường của DeepLink là bao lớn?',
       block1_text: 'Một trong những chức năng của DeepLink có thể được hiểu như là XBOX và PlayStation phi tập trung. Tính đến năm 2023, doanh số toàn cầu của PS5 của Sony đã đạt 50 triệu đơn vị, Xbox Series X|S đã đạt 30 triệu đơn vị, và tổng doanh số của PS và Xbox lên đến hơn 200 triệu đơn vị, thị trường game 3A cao cấp rất lớn.',
       block2_title: 'DeepLink, giống như XBOX và PlayStation, phục vụ game thủ 3A cao cấp, nhưng mô hình kinh doanh hoàn toàn khác biệt',
       block2_text: 'Người chơi DeepLink không cần mua máy chơi game cao cấp. Họ chỉ cần tải phần mềm DeepLink hoặc mua máy chơi game đám mây blockchain tích hợp sẵn hoặc máy chơi game cầm tay đám mây blockchain. Người chơi có thể có được trải nghiệm chơi game 3A giống như XBOX và PlayStation nhưng tiết kiệm đến 80% chi phí phần cứng.',
       block3_title: 'Người khai thác cung cấp máy chơi game 3A cao cấp. Máy chủ là hệ thống Windows và tương thích với tất cả các game 3A của Windows.',
       block3_text: 'Máy chơi game của người khai thác có thể được đặt tại nhà hoặc trong trung tâm dữ liệu. Máy chơi game Xbox và PlayStation chỉ có thể được sử dụng bởi chính họ và không thể cho thuê cho người khác, vì vậy hiệu quả sử dụng rất thấp và có nhiều lãng phí tài nguyên. Máy khai thác game của DeepLink có thể được chia sẻ với bất kỳ ai, từ đó cải thiện việc sử dụng tài nguyên phần cứng và mang lại mô hình kinh doanh mới.',
       block4_title: 'Người khai thác cung cấp máy khai thác game và có thể nhận phần thưởng token DLC',
       block4_text: 'Do đó kích thích thêm nhiều người khai thác cung cấp máy khai thác game, người dùng cần trả token DLC để mua thời gian chơi game, từ đó mở rộng các kịch bản sử dụng của DLC và số lượng người nắm giữ tiền tệ, với quy mô người dùng tiềm năng vượt quá 1 tỷ người.',
      table: {
        table1_text1: 'So sánh chi tiết',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'Chơi game 3A',
        table2_text2: 'Người dùng không cần mua phần cứng, chỉ cần tải phần mềm DeepLink',
        table2_text3: 'Người dùng cần mua phần cứng',
        table2_text4: 'Người dùng cần mua phần cứng',
        table3_text1: 'Máy chơi game',
        table3_text2: 'Bạn có thể cho thuê để kiếm $DLC, có thể cho thuê hơn 12 giờ một ngày và có thể thu hồi vốn trong 10 tháng',
        table3_text3: 'Bạn chỉ có thể sử dụng cho bản thân và không thể cho thuê. Có sự lãng phí tài nguyên phần cứng nếu bạn sử dụng từ 2-4 giờ một ngày',
        table3_text4: 'Bạn chỉ có thể sử dụng cho bản thân và không thể cho thuê. Có sự lãng phí tài nguyên phần cứng nếu bạn sử dụng từ 2-4 giờ một ngày',
        table4_text1: 'Máy chơi game cầm tay',
        table4_text2: 'Được hỗ trợ, có thể kết nối với bất kỳ phần cứng nào',
        table4_text3: 'Không có máy chơi game cầm tay chuyên dụng',
        table4_text4: 'Được hỗ trợ, chỉ có thể kết nối với PS5',
        table5_text1: 'Máy chơi game đám mây tích hợp sẵn',
        table5_text2: 'Hỗ trợ',
        table5_text3: 'Không được hỗ trợ',
        table5_text4: 'Không được hỗ trợ',
        table6_text1: 'Quán net đám mây',
        table6_text2: 'Hỗ trợ',
        table6_text3: 'Không được hỗ trợ',
        table6_text4: 'Không được hỗ trợ'
      },
      btn1: 'Phần mềm DeepLink',
      btn2: 'Giao thức DeepLink',
      btn3: 'Giới thiệu Đội ngũ',
      btn4: 'Mô hình Kinh tế'
    },
    faqs: {
      title: 'CÂU HỎI THƯỜNG GẶP',
      text: 'Bạn có thể có câu hỏi, chúng tôi có câu trả lời.',
      ques_title1: '1.Là gì Bán hàng công khai?',
      ques_text1: 'Trong đợt Bán hàng công khai, một số lượng hạn chế token được bán với một mức giá nhất định cho những người muốn tham gia sớm. Đây là cơ hội tuyệt vời để trở thành một phần của DeepLink trước khi token thực sự được phát hành. Bằng cách tham gia Bán hàng công khai, bạn có thể mua token với giá ưu đãi sớm trước khi nó được phát hành công khai. Do đó, Bán hàng công khai có thể được coi là cơ hội tiềm năng để mua token trước khi chúng được lưu hành và niêm yết trên các sàn giao dịch.',
      ques_title2: '2.Tại sao chúng tôi tiến hành Bán hàng công khai?',
      ques_text2_1: 'Chúng tôi tổ chức Bán hàng công khai để xây dựng một cộng đồng người nắm giữ $DLC mạnh mẽ, cải tiến nền tảng của chúng tôi, huy động vốn và thu hút thêm nhiều game thủ vào hệ sinh thái của chúng tôi.',
      ques_text2_2: 'Các quỹ thu được trong Bán hàng công khai sẽ liên tục được tái đầu tư vào các sản phẩm DeepLink, giới thiệu các tính năng mới và mở rộng cơ sở người dùng thông qua các hoạt động tiếp thị. Điều này sẽ cho phép chúng tôi thực hiện chiến lược tiếp thị trước khi Token $DLC được phát hành.',
      ques_text2_3: 'Mục tiêu của chúng tôi là có 1,000,000,000 người sử dụng DeepLink, điều này sẽ tạo ra các kịch bản sử dụng lớn cho Token $DLC và đảm bảo sự thành công lâu dài của nó. Token $DLC sẽ được niêm yết trên các sàn giao dịch DEX và CEX, thúc đẩy sự phát triển của hệ sinh thái DeepLink.',
      ques_text2_4: 'Tham gia Bán hàng công khai DeepLink ngay bây giờ và trở thành một phần của DeepLink!',
      ques_title3: '3.Điều gì khác biệt giữa DeepLink Protocol và DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol là một giao thức chơi game đám mây AI phi tập trung kết hợp công nghệ AI và blockchain để cung cấp công nghệ kết xuất game siêu thấp độ trễ.',
      ques_text3_2: 'DeepLink Software là một phần mềm điều khiển từ xa game và nền tảng chơi game đám mây được phát triển dựa trên DeepLink Protocol.',
      ques_text3_3: 'Các sản phẩm khác được phát triển dựa trên DeepLink Protocol bao gồm nền tảng quán net eSports đám mây, máy chơi game đám mây blockchain, và thiết bị chơi game cầm tay đám mây blockchain, trong số khác.',
      ques_title4: '4.Điều gì đổi mới về DeepLink Protocol?',
      ques_text4: 'DeepLink giải quyết các khó khăn cốt lõi trong ngành chơi game đám mây thông qua công nghệ blockchain và AI, thu hút các thợ mỏ và máy tính GPU nhàn rỗi với cơ chế khích lệ token và giải quyết hai thách thức chính trong ngành chơi game đám mây. Công nghệ AI được sử dụng để nâng cao đồ họa game và trải nghiệm người dùng.',
      ques_title5: '5.Token $DLC là gì?',
      ques_text5: 'Token $DLC là phiếu thanh toán duy nhất trong hệ sinh thái DeepLink. Người dùng cần trả Token $DLC để mua thời gian chơi game đám mây, thuê máy tính chơi game đám mây, mua quyền cấp phép, v.v.',
      ques_title6: '6.Ai là khách hàng mục tiêu của DeepLink Protocol?',
      ques_text6_1: '1) Các công ty game AAA: Hỗ trợ các game AAA chuyển đổi thành game đám mây, cho phép chúng chạy trên bất kỳ thiết bị cấp thấp nào, bao gồm điện thoại di động, và giúp tăng cơ sở người dùng của các game AAA hơn mười lần.',
      ques_text6_2: '2) Quán internet và khách sạn eSports: Hỗ trợ các quán internet truyền thống nâng cấp thành quán net đám mây, giảm đầu tư phần cứng hơn 80% và tăng lợi nhuận ròng gấp ba lần trong bốn năm.',
      ques_text6_3: '3) Nhà sản xuất máy chơi game đám mây: Tích hợp DeepLink Protocol cho phép chơi các game AAA với cấu hình CPU thấp và màn hình game cao cấp, giúp người chơi tiết kiệm 80% chi phí phần cứng.',
      ques_text6_4: '4) Nhà sản xuất thiết bị chơi game cầm tay đám mây: Các nhà sản xuất tích hợp DeepLink Protocol cung cấp thiết bị cầm tay với chi phí chỉ bằng 30% so với thiết bị cầm tay truyền thống, với hiệu suất chơi game hơn năm lần tốt hơn.',
      ques_title7: '7.Ai là khách hàng mục tiêu của DeepLink Software?',
      ques_text7: 'Họ là 3 tỷ game thủ cá nhân tiềm năng trên toàn thế giới, cho phép game thủ thưởng thức các game AAA cao cấp trên điện thoại di động, máy tính hiệu suất thấp, Mac và TV.',
      ques_title8: '8.Có thời gian hạn chế không?',
      ques_text8: '40% Token DLC mua được mở khóa, và 60% sẽ bắt đầu mở khóa vào khoảng ngày 31 tháng 8 năm 2024, trong 150 ngày, mở khóa 10% mỗi 30 ngày.',
      ques_title9: '9.Làm thế nào để mua $DLC?',
      ques_text9: 'Đầu tiên, tham gia KYC, gửi thông tin cá nhân và một khi được xác minh, bạn có thể tham gia mua $DLC khi Bán hàng công khai bắt đầu.'
    },
    buy: {
      title: 'Cách mua?',
      step1: 'Bước 1:',
      step1_text: 'Kết nối ví của bạn: Sử dụng Metamask hoặc Trust Wallet để kết nối ví trong vài giây',
      step2: 'Bước 2:',
      step2_text: 'Xác nhận giao dịch: Bạn có thể mua $DLC bằng USDT',
      step3: 'Bước 3:',
      step3_text: 'Yêu cầu Token: Xin chúc mừng! Bạn có thể yêu cầu $DLC của mình sau khi Bán hàng công khai kết thúc.',
      btn1: 'Cần trợ giúp',
      btn2: 'Mua DLC', 
    },
    potential: {
      title: 'Tiềm năng tăng trưởng', 
      text1_1: 'Giá trị thị trường của nhiều token trên đường đi của DePIN đã tiếp tục tăng trưởng sau khi được niêm yết trên sàn giao dịch',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: 'Cơ sở người dùng tiềm năng của Phần mềm DeepLink vượt quá 1 tỷ người, điều này sẽ đưa một số lượng lớn người dùng web2 vào thế giới web3, và số người nắm giữ $DLC tiềm năng vượt quá 1 tỷ người.',
      text3: 'Có hơn 200,000 quán net thể thao điện tử trên thế giới. Trong tương lai, hơn 50% các quán internet truyền thống sẽ được chuyển đổi thành quán net đám mây. Công nghệ quán net đám mây có triển vọng ứng dụng rộng rãi. Mỗi quán net đám mây cần sử dụng $DLC để thanh toán, mang lại sự sử dụng rộng rãi của $DLC.',
      text4: 'Tham khảo doanh số bán hàng của XBOX và PS5, số lượng người dùng mua máy chơi game đám mây blockchain tích hợp sẵn và máy chơi game cầm tay đám mây blockchain sẽ vượt quá 100 triệu, điều này sẽ mang lại giá trị lớn cho $DLC.'
    },
    report: {
      title: 'Báo cáo Truyền thông DeepLink'
    },
    prompt: {
      title: 'Mẹo giải thích',
      text1: 'DeepCloudX.PTE.LTD vận hành trang web deeplink.cloud (nền tảng "Platform").',
      text2: 'Bằng cách sử dụng nền tảng này, bạn chấp nhận Điều khoản Dịch vụ, Chính sách Riêng tư, Chính sách Cookie và Thỏa thuận Bán Token DLC của chúng tôi. Tiền điện tử có thể không được quản lý tại quyền hạn của bạn. Giá trị của tiền điện tử có thể tăng hoặc giảm. Lợi nhuận có thể bị ảnh hưởng bởi thuế suất vốn hay các loại thuế khác áp dụng trong quyền hạn của bạn. Không có gì trên trang web này được coi là lời đề nghị hoặc khuyến nghị mua, bán hoặc đầu tư. Bạn hoàn toàn chịu trách nhiệm xác định xem mua hay giao dịch liên quan có phù hợp với bạn không, dựa trên mục tiêu cá nhân, tình hình tài chính và mức độ chịu rủi ro của bạn.',
      text3: 'Bạn nên tham khảo ý kiến của các chuyên gia pháp lý, cố vấn thuế, bảo hiểm hoặc kinh doanh có giấy phép và đáng tin cậy. DLC không đảm bảo bất kỳ hiệu suất, kết quả hay lợi tức vốn nào đối với bất kỳ loại tiền điện tử nào trên trang web này. Bằng cách truy cập trang web này và bất kỳ trang nào của nó, bạn đồng ý bị ràng buộc bởi Thỏa thuận Bán DLC. Mua tiền điện tử có rủi ro và có thể dẫn đến mất một phần hoặc toàn bộ.',
    }
  },
  dialog1: {
    title: 'Nộp thông tin KYC',
    text1: 'Tải lên thông tin nhận dạng:',
    text2: 'Tải lên thông tin nhận dạng cầm tay:',
    text3: 'Thông tin mặt trước của thẻ căn cước, hộ chiếu hoặc giấy phép lái xe của bạn',
    text4: 'Cần nhìn rõ mặt trước và thông tin nhận dạng',
    text5: 'Số lượng yêu cầu mua DLC:',
    text6: 'Địa chỉ ví được chứng nhận:',
    text7: '1000 DLC sẽ được thưởng sau khi vượt qua chứng nhận KYC, và DLC bị khóa trong Bán hàng công khai cũng sẽ được gửi đến địa chỉ ví này',
    text7_1: 'Chỉ địa chỉ này mới có thể mua DLC nếu vượt qua xác minh KYC và không thể là địa chỉ sàn giao dịch.',
    text8: 'Ở đâu để tạo địa chỉ ví DLC của chuỗi DBC?',
    text9: 'hoặc',
    text10: 'Nhập địa chỉ email:',
    text11: 'Nhận mã xác minh',
    text12: 'Nhập mã xác minh:',
    text13: 'Lấy lại trong {secs} giây',
    text14: '(Số lượng tối đa là 20,000,000 DLC. Tại thời điểm bắt đầu Bán hàng công khai, chỉ có số lượng đã vượt qua chứng nhận KYC mới có thể mua)',

    success1: 'Mã xác minh đã được gửi!',
    success2: 'Thông tin đã gửi thành công, đang chờ xét duyệt',
    error1: 'Bạn phải chọn một tệp hình ảnh!',
    error2: 'Tệp hình ảnh không được để trống!',
    error3: 'Tên người dùng không được để trống!',
    error4: 'Địa chỉ ví không được để trống!',
    error5: 'Hộp thư không được để trống!',
    error6: 'Vui lòng nhập địa chỉ email chính xác!',
    error7: 'Mã xác minh không được để trống!',
    error8: 'Không gửi được mã xác minh, vui lòng thử lại sau!',
    error9: 'Thêm thất bại',
    error10: 'Lỗi mã xác minh, vui lòng thử lại',
    error11: 'Không truy vấn được thông tin email',
    error12: 'Số lượng mua không được vượt quá 20,000,000',
    error13: 'Mã xác minh hết hạn, vui lòng lấy lại',
    error14: 'Thông tin đã được nộp thành công, nhưng email xác nhận không thành công.',
    error15: 'Nếu bạn không nhận được email, vui lòng kiểm tra xem nó có bị đặt trong thư rác không',
    error16: 'Kích thước tối đa tải lên cho hình ảnh không được vượt quá 5MB!',
    error17: 'Vui lòng không nộp dữ liệu xác minh KYC lặp đi lặp lại',
    tip1: '(Lời nhắc thân thiện: Thông tin nhận dạng cá nhân chỉ được sử dụng cho KYC và sẽ không được sử dụng cho bất kỳ mục đích nào khác.)'
  },
  dialog2: {
    title: 'Mua DLC',
    text1: 'Số lượng yêu cầu mua DLC:',
    text2: 'Yêu cầu mua tối thiểu 150,000 DLC',
    text3: 'Chọn tiền tệ thanh toán:',
    text4: 'Nhập địa chỉ ví DLC của chuỗi DBC:',
    // text5: 'DLC bị khóa sẽ được chuyển đến địa chỉ ví này. Vui lòng xác nhận tính chính xác của địa chỉ ví để tránh không nhận được DLC!',
    text5: '40% DLC sẽ được chuyển đến địa chỉ ví này trong vòng vài phút và 60% DLC còn lại sẽ được chuyển đến địa chỉ ví này khi khóa hết hạn.',
    text6: 'Ở đâu để tạo địa chỉ ví DLC của chuỗi DBC?',
    text7: 'hoặc',
    text8: 'Tương đương USDT:',
    text9: 'Chọn phương thức thanh toán:',
    text9_1: 'Thanh toán bằng ví đã kết nối hiện tại',
    text9_2: 'Quét mã QR để thanh toán',

    error1: 'Số lượng DLC không được để trống',
    error2: 'Vui lòng nhập một con số',
    error3: 'Số nhập vào phải lớn hơn 50,000',
    error4: 'Địa chỉ ví không được để trống',
    error5: 'Tạo đơn hàng thất bại',
    success1: 'Thanh toán thành công, DLC sẽ được chuyển đến địa chỉ ví của bạn trong vòng vài phút, các bạn chú ý kiểm tra nhé!',
    success2: 'Sau khi thanh toán thành công qua jump link, DLC sẽ được chuyển đến địa chỉ ví của bạn trong vòng vài phút, các bạn chú ý kiểm tra nhé!',

    error6: 'Số lượng USDT không được để trống',
    error7: 'Số lượng USDT không được nhỏ hơn 150',
    error8: 'Số lượng USDT không được lớn hơn 60000',
    error9: 'Số tiền thanh toán không khớp với số tiền gửi trước. Vui lòng liên hệ với quản trị viên để xác nhận xem số tiền đó có chính xác hay không.'
  },
  dialog3: {
    title: 'Giới thiệu về máy tích hợp',
    text1: '1. Máy chơi game đám mây tích hợp là gì?',
    text2: 'So với màn hình tích hợp truyền thống, máy chơi game đám mây tích hợp có tốc độ làm mới FPS cao, đạt được trải nghiệm chơi game mượt mà. Máy tích hợp chơi game đám mây TIKEREN của Nhóm HKC được phát triển dựa trên công nghệ DeepBrainChain+DeepLink và có thể kết nối với sức mạnh tính toán GPU hiệu suất cao từ xa trong thời gian thực để kết xuất và tính toán game. Máy tích hợp có hệ thống Windows tích hợp và có thể được sử dụng cho các mục đích văn phòng và giải trí bình thường. Nó có thể phát trực tuyến sang các máy chủ GPU hiệu suất cao khác để chơi game thông qua DeepLink. Khi bạn không có máy chủ GPU hiệu suất cao, bạn có thể kết nối với GPU hiệu suất cao từ xa thông qua DeepLink để chơi các trò chơi AAA. Bạn chỉ cần trả một số Token DLC nhất định mỗi giờ.',
    text3: '2. Hiển thị máy tích hợp TIKEREN',
    table: {
      th: {
        text1: 'Mục',
        text2: '27 inch',
        text3: '31.5 inch',
      },
      td1: {
        text1: 'Loại màn hình',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Màu sắc',
        text2: 'Đen',
        text3: 'Đen'
      },
      td3: {
        text1: 'Kích thước hiển thị',
        text2: '27 inch',
        text3: '31.5 inch'
      },
      td4: {
        text1: 'Tỷ lệ khung hình',
        text2: 'Rộng (16:9)',
        text3: 'Rộng (16:9)'
      },
      td5: {
        text1: 'Loại tấm nền',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Độ phân giải tấm nền',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Tốc độ làm mới tấm nền',
        text2: '180Hz (Tối đa)',
        text3: '170Hz(Tối đa)'
      },
      td8: {
        text1: 'Thời gian đáp ứng',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Dải màu',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Giải pháp bo mạch chủ',
        text2: 'Bộ chipset Intel® N100',
        text3: 'Bộ chipset Intel® N100'
      },
      td11: {
        text1: 'CPU/Làm mát',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Bộ nhớ',
        text2: 'DDR4 8GB(Tối đa 32G)',
        text3: 'DDR4 8GB(Tối đa 32G)'
      },
      td13: {
        text1: 'Ổ cứng',
        text2: 'SSD 128G(Tối đa 1T)',
        text3: 'SSD 128G(Tối đa 1T)'
      },
      td14: {
        text1: 'Hệ điều hành',
        text2: 'Windows 10/11(Tùy chọn)',
        text3: 'Windows 10/11(Tùy chọn)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Đồ họa Intel UHD',
        text3: 'Đồ họa Intel UHD'
      },
      td16: {
        text1: 'Giao diện sau',
        text2: '1*Cổng Nguồn DC, 1*RJ45(2.5G), 4* USB 3.0, 1*Jack cắm âm thanh',
        text3: '1*Cổng Nguồn DC, 1*HDMIN, 1*HDMI OUT, 1*RJ45(2.5G), 4* USB 3.0, 1*Jack cắm âm thanh'
      },
      td17: {
        text1: 'Giao diện bên',
        text2: 'USB 2.0x2, Nút nguồn x1',
        text3: 'USB 2.0x2, Nút nguồn x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5), BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5), BT(4.2)'
      },
      td19: {
        text1: 'Âm thanh',
        text2: 'Loa tích hợp*2',
        text3: 'Loa tích hợp*2'
      },
      td20: {
        text1: 'Chân đế',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Trục xoay',
        text2: 'Lên, xuống, trái, phải, xoay 90°, nâng',
        text3: 'Lên, xuống, trái, phải, xoay 90°, nâng'
      },
      td22: {
        text1: 'Nguồn điện',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Cải thiện màn hình chơi game',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'Tôi đã hiểu'
  },
  dialog4: {
    title: 'Giới thiệu về Máy chơi game cầm tay đám mây',
    text1: '1. Máy chơi game cầm tay đám mây là gì?',
    text2: 'So với máy chơi game cầm tay truyền thống, máy chơi game đám mây được phát triển dựa trên công nghệ kết xuất độ trễ cực thấp của DeepLink. Nó có thể kết nối với sức mạnh tính toán hiệu suất cao của máy chủ GPU đám mây trong thời gian thực để kết xuất game, giảm chi phí của máy chơi game 70% và đạt được trải nghiệm chơi game 3A mượt mà. Thiết bị cầm tay tích hợp Google Play có thể tải xuống các trò chơi Android, và bạn cũng có thể chơi game bằng cách phát trực tuyến tới máy chủ GPU Windows hiệu suất cao khác/PS/XBOX của riêng mình. Khi bạn không có máy chủ GPU hiệu suất cao, bạn cũng có thể kết nối với máy chủ GPU hiệu suất cao từ xa thông qua DeepLink để chơi các trò chơi AAA. Bạn chỉ cần trả một lượng Token DLC nhất định mỗi giờ.',
    text3: '2. Hiển thị máy chơi game cầm tay đám mây blockchain',
    btn: 'Tôi đã hiểu'
  },
  dialog5: {
    title: 'Giới thiệu về Máy đào game GPU tại nhà',
    text1: '1. Máy đào game GPU tại nhà là gì?',
    text2: 'Máy đào game GPU đi kèm với GPU NVIDIA 4070 Super, CPU Intel i7-13700F, 32G bộ nhớ, 2T dung lượng ổ cứng SSD, phần mềm đào DeepLink và hệ thống quản lý được tích hợp sẵn. Bất kỳ ai cũng có thể đặt máy này tại nhà để kiếm phần thưởng DLC, và có 1 tỷ Token DLC được trao cho tất cả các máy đào game. Bất kể người dùng có thuê máy để chơi game hay không, họ cũng có thể nhận được phần thưởng DLC. Khi bạn thiết lập máy đào game GPU cho thuê, bạn có thể nhận được phần thưởng DLC và thu nhập cho thuê DBC. Khi không có người dùng thuê, bạn cũng có thể đào các token khác, có thể tạo ra thu nhập 24 giờ một ngày.',
    text3: '2. Hiển thị máy đào game GPU tại nhà',
    text4: '3. Giới thiệu thông số kỹ thuật',
    text5_1: 'Với Card đồ họa RTX4070 Super',
    text5_2: 'Core i7-13700F, 16 lõi, 24 luồng, Cơ bản 1.5/2.1 GHz, Tối đa 4.1/5.1GHz;',
    text5_3: 'Card đồ họa GeForce RTX4070 Supe12G. Hỗ trợ Dò tia thế hệ thứ 3 và Lõi Tensor thế hệ thứ 4.',
    text5_4: 'RAM DDR4 kép, Tối đa 64GB (32GB*2).',
    text5_5: 'Cổng ổ cứng Một M2 2280 NVME SSD, và hỗ trợ thêm đôi ổ cứng SATA 2.5".',
    text5_6: 'Cổng 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Quang, 1*Âm thanh, 1*DC-IN, 2*Cổng WiFi.',
    text5_7: 'Hệ điều hành Cài đặt sẵn Windows 11 Pro.',
    btn: 'Tôi đã hiểu'
  }
}